export default "__VITE_ASSET__Bw$h5e_j__"